module.exports = __webpack_public_path__ + "assets/img/page_9.fe999156.png";